/**
 * Shared keyboard activation for role="radio" tiles (Enter / Space).
 *
 * @param {KeyboardEvent} event
 * @param {boolean} isDisabled
 * @param {Function} onActivate
 */
export function handleRadioTileKeyDown(event, isDisabled, onActivate) {
  if (isDisabled) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onActivate();
  }
}
